<template>
      <span class="font_1" v-if="records">{{ records.examName }}</span>
  
      <el-row>
      <el-col :span="6">
        <el-statistic title="合格率" :value="records && records.qualified.substr(0, 5) + '%'" >
        <template #suffix>
          <el-icon style="vertical-align: -0.125em">
              <GoldMedal />
          </el-icon>
          </template>
      </el-statistic>
      </el-col>
      <el-col :span="6">
          <el-statistic title="作业提交状况" :value="records && records.submitCondition" >
          <template #suffix>
              <el-icon style="vertical-align: -0.125em">
                  <Odometer />
              </el-icon>
              </template>
          </el-statistic>
      </el-col>
      <el-col :span="6">
        <el-statistic title="开始时间" :value="records && records.startTime" >
        <template #suffix>
            <el-icon style="vertical-align: -0.125em">
              <Clock />
            </el-icon>
          </template>
          </el-statistic>
      </el-col>
      <el-col :span="6">
        <el-statistic title="结束时间" :value="records && records.stopTime">
          <template #suffix>
            <el-icon style="vertical-align: -0.125em">
              <Clock />
            </el-icon>
          </template>
        </el-statistic>
      </el-col>
    </el-row>
  </template>
  
  <script setup>
  import { ref, onMounted } from "vue";
    import { ElMessage } from "element-plus";
    import $ from "jquery";
    import { useRoute } from "vue-router";

    let courseId = ref('');
    let examId = ref('');
    let records = ref();
    const Route = useRoute(); //获取到值

    // 在组件初始化时获取路由参数并设置为 current_page
    onMounted(() => {
    courseId.value = Route.params.courseId || '';
    examId.value = Route.params.examId || '';

    pullRecords();
    });


    // 加载记录信息
    const pullRecords = () => {

    const token = localStorage.getItem("token");
    $.ajax({
        url: "http://124.222.105.205:5000/api/homework/getHomeworkRecordStatistics",
        data: {
            examId: examId.value,
            courseId: courseId.value
        },
        type: "post",
        headers: {
        Authorization: "Bearer " + token,
        },
        success(resp) {
            records.value = resp.data;
            console.log(records.value);

        },
        error() {
        ElMessage({
            type: "error",
            message: "拉取作业统计失败!"
        });
        },
    });
    };

  </script>
  
  <style scoped>
  
  .font_1{
      font-size: 20px;
      font-weight: bold;
      color: rgb(112, 112, 112);
  }
  
  
  </style>